<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-card class="com-pc-card tm-pcfull-detail-past">
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title pb-4">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                x-small
                class="mb-4"
                color="white"
                v-clipboard:copy="copyValues"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ text.copy }}</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="tm-pcfull-detail-copy-dialog">
                <span class="message">{{ text.dialogMessage }}</span>
              </v-card-title>
            </v-card>
          </v-dialog>
          <div>
            <v-btn
              outlined
              x-small
              class="mb-4 ml-2"
              color="white"
              @click="print"
            >
              <span>{{ text.print }}</span>
            </v-btn>
          </div>
          <v-btn text icon color="white" @click="$emit('close')" class="pb-4">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-row class="com-pc-card-contents ma-0">
          <v-col class="scroll">
            <v-simple-table class="table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      v-for="title in headers1"
                      :key="title.key"
                      nowrap
                      :colspan="title.col"
                      class="head-item"
                      :class="title.cls"
                    >
                      {{ title.text }}
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-for="title in headers2"
                      :key="title.key"
                      class="head-item px-1"
                      :class="title.cls"
                    >
                      {{ title.text }}
                    </th>
                  </tr>
                </thead>
                <tbody v-show="!loading">
                  <tr v-for="time of 24" :key="time">
                    <td
                      v-for="item of items(time)"
                      :key="item.key"
                      :class="item.cls"
                    >
                      <span
                        v-if="showWtrQualHighlight(item.ovcd)"
                        class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                        :rw-info-color="setWtrQualInfoColor(item.ovcd)"
                      >
                        {{ item.text }}
                      </span>
                      <span v-else> {{ item.text }} </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-row
            v-show="loading"
            align="center"
            justify="center"
            class="progress"
          >
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              justify-center
            ></v-progress-circular>
          </v-row>
        </v-row>
      </v-card>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 水質観測所詳細 過去データ表示
 * TmWtrQualDetailPast.vue
 * @author LIS
 */
import util from "./../../../lib/util";
import tmObs from "./../../../lib/tmObs";

export default {
  name: "tm-wtr-qual-detail-past",
  data() {
    return {
      text: {
        title: "過去一週間のデータ",
        other: "--",
        header1: "日付",
        header2: "観測項目",
        temp: "水温\r\n[℃]",
        ph: "pH",
        dox: "DO\r\n[mg/l]",
        cond: "導電率\r\n[mS/m]",
        turb: "濁度\r\n[度]",
        cod: "COD\r\n[mg/l]",
        qwtrDbObs: "水文水質観測所情報",
        qwtrDbStgRk: "水文水質観測所水位ランキング",
        qwtrDbMsg:
          "さらに過去のデータをご覧になりたい場合は、このボタンのリンク先をご利用ください",
        copy: "コピー",
        dialogMessage: "コピーしました。",
        print: "印刷",
      },
      yesterday: util.toDate(),
      dialog: false,
    };
  },
  created() {
    this.$log.debug("[TmWtrQualDetailPast] created()");
    this.yesterday = util.formatDate(
      util.subDays(this.appTime, 1),
      "YYYY-MM-DD"
    );

    this.$store.dispatch("Telemeter/getSelectedTmWtrQualPast", {
      date: this.appTime,
    });
  },
  computed: {
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    headers1: {
      get() {
        let header = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        for (let day = 6; day >= 0; day--) {
          let title = util.formatDate(
            util.subDays(this.yesterday, day),
            "MM/DD"
          );
          let head = {
            text: title,
            key: "day" + day,
            col: 6,
            cls: "first",
          };
          header.push(head);
        }
        return header;
      },
    },
    headers2: {
      get() {
        let header = [
          { text: this.text.header2, key: "title", cls: "top-2nd" },
        ];
        for (let day = 6; day >= 0; day--) {
          let head = {
            text: this.text.temp,
            key: "temp" + day,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.ph,
            key: "ph" + day,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.dox,
            key: "dox" + day,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.cond,
            key: "cond" + day,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.turb,
            key: "turb" + day,
            cls: "second",
          };
          header.push(head);
          head = {
            text: this.text.cod,
            key: "cod" + day,
            cls: "second",
          };
          header.push(head);
        }
        return header;
      },
    },
    loading: {
      get() {
        return this.$store.state.Telemeter.selectedTmPast == null;
      },
    },
    qwtrDb: {
      get() {
        return {
          qwtrObsCd: this.$store.state.Telemeter.selectedTm.tmQwtrDetailInfo
            .qwtrObsCd,
          dbLink: this.$store.state.Telemeter.selectedTm.tmQwtrDetailInfo
            .dbLink,
        };
      },
    },
    /** クリップボードコピー用 */
    copyValues: {
      get() {
        const pastList = this.$store.state.Telemeter.selectedTmPast;
        let resultList = [];
        resultList.push(tmObs.getCopyHeader(this.headers1, 6));
        resultList.push(tmObs.getCopyHeader(this.headers2));
        for (let hour = 1; hour <= 24; hour++) {
          let time = util.formatDate(util.toDate().setHours(hour), "HH:00");
          if (time == "00:00") {
            time = "24:00";
          }
          let item = time + "\t";
          if (null != pastList && Object.keys(pastList).length > 0) {
            for (let day = 6; day >= 0; day--) {
              let date = util.formatDate(
                util.subDays(this.yesterday, day),
                "YYYY/MM/DD"
              );
              let temp = this.text.other;
              let ph = this.text.other;
              let dox = this.text.other;
              let cond = this.text.other;
              let turb = this.text.other;
              let cod = this.text.other;
              let key = date + time;
              if (key in pastList) {
                temp = tmObs.checkCcd(
                  pastList[key].temp,
                  pastList[key].tempCcd,
                  1
                );
                ph = tmObs.checkCcd(pastList[key].ph, pastList[key].phCcd, 1);
                dox = tmObs.checkCcd(
                  pastList[key].dox,
                  pastList[key].doxCcd,
                  1
                );
                cond = tmObs.checkCcd(
                  pastList[key].cond,
                  pastList[key].condCcd,
                  1
                );
                turb = tmObs.checkCcd(
                  pastList[key].turb,
                  pastList[key].turbCcd,
                  1
                );
                cod = tmObs.checkCcd(
                  pastList[key].cod,
                  pastList[key].codCcd,
                  1
                );
              }
              item +=
                temp +
                "\t" +
                ph +
                "\t" +
                dox +
                "\t" +
                cond +
                "\t" +
                turb +
                "\t" +
                cod +
                (day != 0 ? "\t" : "");
            }
          } else {
            // 過去一週間の情報が取得出来なかった場合
            for (let day = 6; day >= 0; day--) {
              item +=
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                "\t" +
                this.text.other +
                (day != 0 ? "\t" : "");
            }
          }
          resultList.push(item);
        }
        return resultList.join("\n");
      },
    },
  },
  watch: {
    dialog() {
      // 指定秒後ダイアログを閉じる
      setTimeout(() => {
        this.dialog = false;
      }, 1000);
      // 指定秒後ボタンのfocusを解除する
      setTimeout(() => {
        const elem = document.activeElement;
        elem.blur();
      }, 1200);
    },
  },
  methods: {
    items(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead", ovcd: "" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          let temp = this.text.other;
          let tempovcd = 0;
          let ph = this.text.other;
          let phovcd = 0;
          let dox = this.text.other;
          let doxovcd = 0;
          let cond = this.text.other;
          let condovcd = 0;
          let turb = this.text.other;
          let turbovcd = 0;
          let cod = this.text.other;
          let codovcd = 0;
          let key = date + time;
          if (key in pastList) {
            temp = tmObs.checkCcd(pastList[key].temp, pastList[key].tempCcd, 1);
            tempovcd = pastList[key].tempOvcd;
            ph = tmObs.checkCcd(pastList[key].ph, pastList[key].phCcd, 1);
            phovcd = pastList[key].phOvcd;
            dox = tmObs.checkCcd(pastList[key].dox, pastList[key].doxCcd, 1);
            doxovcd = pastList[key].doxOvcd;
            cond = tmObs.checkCcd(pastList[key].cond, pastList[key].condCcd, 1);
            condovcd = pastList[key].condOvcd;
            turb = tmObs.checkCcd(pastList[key].turb, pastList[key].turbCcd, 1);
            turbovcd = pastList[key].turbOvcd;
            cod = tmObs.checkCcd(pastList[key].cod, pastList[key].codCcd, 1);
            codovcd = pastList[key].codOvcd;
          }
          let body = {
            text: temp,
            key: date + time + "temp",
            cls: "body",
            ovcd: tempovcd,
          };
          item.push(body);
          body = {
            text: ph,
            key: date + time + "ph",
            cls: "body",
            ovcd: phovcd,
          };
          item.push(body);
          body = {
            text: dox,
            key: date + time + "dox",
            cls: "body",
            ovcd: doxovcd,
          };
          item.push(body);
          body = {
            text: cond,
            key: date + time + "cond",
            cls: "body",
            ovcd: condovcd,
          };
          item.push(body);
          body = {
            text: turb,
            key: date + time + "turb",
            cls: "body",
            ovcd: turbovcd,
          };
          item.push(body);
          body = {
            text: cod,
            key: date + time + "cod",
            cls: "body",
            ovcd: codovcd,
          };
          item.push(body);
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          let temp = this.text.other;
          let ph = this.text.other;
          let dox = this.text.other;
          let cond = this.text.other;
          let turb = this.text.other;
          let cod = this.text.other;

          let body = {
            text: temp,
            key: date + time + "temp",
            cls: "body",
          };
          item.push(body);
          body = {
            text: ph,
            key: date + time + "ph",
            cls: "body",
          };
          item.push(body);
          body = {
            text: dox,
            key: date + time + "dox",
            cls: "body",
          };
          item.push(body);
          body = {
            text: cond,
            key: date + time + "cond",
            cls: "body",
          };
          item.push(body);
          body = {
            text: turb,
            key: date + time + "turb",
            cls: "body",
          };
          item.push(body);
          body = {
            text: cod,
            key: date + time + "cod",
            cls: "body",
          };
          item.push(body);
        }
      }
      return item;
    },
    print() {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            appTime: util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            type: "past",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      } else {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            type: "past",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      }
    },
    /**
     * 超過観測所 着色
     */
    setWtrQualInfoColor(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return "danger";
      }
    },
    /** 超過の強調表示をするか */
    showWtrQualHighlight(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return true;
      }
      return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
